import { render, staticRenderFns } from "./Ausencias.vue?vue&type=template&id=d772e74c&"
import script from "./Ausencias.vue?vue&type=script&lang=js&"
export * from "./Ausencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports